import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlanoContasEmpresaListarRoutingModule } from './plano-contas-empresa-listar-routing.module';
import { PlanoContasEmpresaListarComponent } from './plano-contas-empresa-listar.component';
import { ConfirmationService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from "primeng/ripple";


@NgModule({
  declarations: [
    PlanoContasEmpresaListarComponent
  ],
  imports: [
    CommonModule,
    PlanoContasEmpresaListarRoutingModule,
    DividerModule,
    MessagesModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    RippleModule
],
  providers: [ConfirmationService]
})
export class PlanoContasEmpresaListarModule { }
